/* eslint-disable max-len */
import { Children } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, TabPanel, TabList } from "react-tabs";
import { SectionTitleType } from "@streamo/helper/types";

const MyAccountTabArea = ({ children }) => {
    const childArr = Children.toArray(children);
    return (
        <section className="login-register-section bg-black section-space-ptb-90">
            <div className="container">
                <Tabs>
                    <TabList className="text-center mb-14">
                        {childArr?.map((item) => (
                            <Tab
                                key={item.key}
                                className="login-register-nav text-white inline-block text-xl pr-4 mr-4 last:mr-0 last:pr-0 border-r-2 border-solid border-red-600 last:border-none"
                            >
                                {item?.props?.data?.section_title?.title && (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: item.props.data
                                                .section_title.title,
                                        }}
                                    />
                                )}
                            </Tab>
                        ))}
                    </TabList>
                    <div className="tab-content">
                        {childArr?.map((item) => (
                            <TabPanel key={item.key}>{item}</TabPanel>
                        ))}
                    </div>
                </Tabs>
            </div>
        </section>
    );
};
MyAccountTabArea.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
    }),
    children: PropTypes.node.isRequired,
};
export default MyAccountTabArea;
